import React, { useContext } from "react"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faExpandAlt, faCompressAlt } from "@fortawesome/free-solid-svg-icons"

import Card from "./Card"
import SkillLogoTag from "./SkillLogoTag"
import SkillIconTag from "./SkillIconTag"
import DropDownContext from "./DropDownContext"

const StyledHead = styled(Card)`
  display: grid;
  grid-template-columns: auto 1.5rem;
  cursor: pointer;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
`

const Icon = styled(FontAwesomeIcon)`
  color: var(--gray-text);
  opacity: 75%;
  user-select: none;
`

type Props = {
  name: string
  icon: string | IconDefinition
  iconcolor?: string
  proficiency: string
}

const CollapsableSkillHead = ({name, icon, iconcolor="", proficiency}: Props) => {
  const { isDropped } = useContext(DropDownContext)

  return (
    <StyledHead>
      
      {typeof icon === "string"
      ? <SkillLogoTag
          name={name}
          icon={icon}
          proficiency={proficiency}
        />
      : <SkillIconTag
          name={name}
          icon={icon}
          iconcolor={iconcolor}
          proficiency={proficiency}
        />
      }
      <IconContainer>
        <Icon
          icon={isDropped ? faCompressAlt : faExpandAlt }
        />
      </IconContainer>
    </StyledHead>
  )
}

export default CollapsableSkillHead